import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@app/gateway/services/api.service';
import { TokenService } from '@app/services/token/token.service';
import { HttpHeaders } from '@angular/common/http';

export interface Wonder{
  mcoProviderDetailsResponse: MCOProviderDetailsResponse[];
}

export interface MCOProviderDetailsResponse{
  mcoId: number;
  mcoName: string;
  mcoLogo: string;
  mcoContactNumber: string;
  mcoTty: string;
  mcoUrl: string;
}
@Injectable({
  providedIn: 'root'
})
export class HealthPlanService {
  constructor(public apiService: ApiService, private token: TokenService) { 
  }

  getHealthPlanProviderDetails(): Observable<any>{
    const url = 'publ/mcoservices/mcoproviderdetails';
    return this.apiService.get(url, true, {headers: new HttpHeaders({'pageId': 'TCCHP', 'sessionId': this.token.getSessionId()})});
  }
}